import React, { type FunctionComponent, useMemo } from 'react'
import { useRetailersList } from 'legacy/common/utils/retailers-list/retailersList.hooks'
import { dashPixels } from 'legacy/dash-blocks/foundation/spacing-units/spacingUnits.types'
import { SimpleSelect } from 'legacy/dash-components/simple-select/SimpleSelect'
import { type OverridableStyles } from 'legacy/common/utils/styling/styling.types'
import { type TestableProps } from 'legacy/common/utils/testing/testing.types'

interface Props extends OverridableStyles, TestableProps {
  value: string
  onChange: (nextValue: string) => void
}

// Note that the value of our retailerId is a string
// This is because GraphQL treats IDs as strings, and it is stored as a string in the
// query params, so seemed easiest to keep it as a string everywhere
export const RetailerSelect: FunctionComponent<Props> = ({ value, onChange, ...rest }) => {
  const { loading, error, data } = useRetailersList()

  const options = useMemo(() => {
    if (loading || error || !data) return []

    return data.map(({ id, name }) => ({ value: id.toString(), label: name }))
  }, [data, error, loading])

  // If there are fewer than 2 options, we just want to hide the retailer selector
  if (options.length < 2) {
    return null
  }

  return (
    <SimpleSelect<string>
      value={value}
      options={options}
      loading={loading}
      error={error}
      onChange={onChange}
      width={dashPixels.PX160}
      {...rest}
    />
  )
}
